import React, { FC } from 'react';
import { useClsTeamCompositionQuery } from '../api';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';

interface TeamCompositions extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
  disabled?: boolean;
}

const TeamComposition: FC<TeamCompositions> = ({ label, error, control, name, rules, disabled }) => {
  const { data } = useClsTeamCompositionQuery();
  return (
    <Select
      label={label}
      data={(data && data.classifierValues) || []}
      control={control}
      error={error}
      name={name}
      rules={rules}
      disabled={disabled}
    />
  );
};

export default TeamComposition;
